import { useEffect, useCallback } from "react";

const useOutsideClick = (ref, callback, auxRef = undefined) => {
  const handleClick = useCallback(
    (e) => {
      // Verifica se o clique foi dentro da ref principal
      const insideMain = ref.current && ref.current.contains(e.target);
      // Verifica se foi dentro da ref auxiliar (o botão, por exemplo)
      const insideAux =
        auxRef && auxRef.current && auxRef.current.contains(e.target);

      if (!insideMain && !insideAux) {
        callback();
      }
    },
    [ref, callback, auxRef]
  );

  useEffect(() => {
    // Usar mousedown evita problemas com elementos que somem no click
    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [handleClick]); // Agora o listener só muda se necessário
};

export default useOutsideClick;

// import { useEffect } from "react";

// const useOutsideClick = (ref, callback, auxRef = undefined) => {
//   const handleClick = (e) => {
//     //console.log("useOutsideClick", { ref, auxRef });
//     if (auxRef && auxRef.current) {
//       if (
//         ref.current &&
//         !ref.current.contains(e.target) &&
//         auxRef.current &&
//         !auxRef.current.contains(e.target)
//       ) {
//         callback();
//       }
//     } else {
//       if (ref.current && !ref.current.contains(e.target)) {
//         callback();
//       }
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("click", handleClick);

//     return () => {
//       document.removeEventListener("click", handleClick);
//     };
//   });
// };

// export default useOutsideClick;
